import { render, staticRenderFns } from "./cataractnnvmp.vue?vue&type=template&id=768c1def&scoped=true"
import script from "./cataractnnvmp.vue?vue&type=script&lang=js"
export * from "./cataractnnvmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c1def",
  null
  
)

export default component.exports